import { render } from "./Examtypelist.vue?vue&type=template&id=554cc0d8&scoped=true"
import script from "./Examtypelist.vue?vue&type=script&lang=js"
export * from "./Examtypelist.vue?vue&type=script&lang=js"

import "./Examtypelist.vue?vue&type=style&index=0&id=554cc0d8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-554cc0d8"]])

export default __exports__